<template>
  <div>
    <div class="page-header page-header-small" style="z-index:2;">
      <parallax
              class="page-header-image"
              style="background-image: url('img/background.jpg')!important;background-color:rgba(0,0,0,0)!important;"
      >
      </parallax>
      <div class="content-center">
        <div class="container">
          <h1 class="title">TERMS OF USE</h1>
        </div>
      </div>
    </div>
    <div class="col-md-10 col-sm-12 offset-md-1" style="padding:4rem!important;padding-top:0px!important;margin-top:-90px;">
      <div style="border-radius: 15px;background-color:#f2f0f0;z-index: 3;" class="section section-about-us">
        <div class="container" style="padding:25px;">
          <div class="separator separator-primary"></div>
          <p class="c17" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">These
   terms and conditions (“User Terms”) apply to your visit to and use, of the Site
   whether through a computer or a mobile phone, the Service and the Application,
   as well as to all information, recommendations and or services provided to You
   on or through the Site, the Service and the Application. This document is an
   electronic record in terms of Information Technology Act, 2000 and rules
   thereunder as applicable and the provisions pertaining to electronic records in
   various statutes as amended by the Information Technology Act, 2000. This
   electronic record is generated by a computer system and does not require any
   physical or digital signatures. By clicking on the “I ACCEPT” button, you are
   consenting to be bound by these User Terms. PLEASE ENSURE THAT YOU READ AND
   UNDERSTAND ALL THESE USER TERMS BEFORE YOU USE THE SITE. If You do not accept
   any of the User Terms, then please do not use the Site or avail any of the
   services being provided therein. YOUR AGREEMENT TO THESE USER TERMS SHALL OPERATE
   AS A BINDING AGREEMENT BETWEEN YOU AND TRANSPO IN RESPECT OF THE USE AND
   SERVICES OF THE SITE.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c31" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">By
   accepting these User Terms, you also allow Transpo to send you promotional
   emails and SMS alerts from time to time.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">IT
   IS HEREBY EXPRESSLY CLARIFIED THAT THESE USER TERMS WILL NOT APPLY TO CORPORATE
   ENTITIES WHO ARE GOVERNED BY THE TRANSPO CORPORATE TERMS OF USE. HOWEVER, ALL
   AUTHORIZED USERS TAKING ‘TRANSPO CORPORATE RIDES’ I.E., FOR CUSTOMERS WHO ARE
   AVAILING RIDES UNDER THE DIRECT ARRANGEMENTS BETWEEN CORPORATE ENTITIES AND
   TRANSPO SHALL ALSO BE GOVERNED BY THESE USER TERMS.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c54" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">1.
   DEFINITIONS</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c11" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">All
   of the defined and capitalized terms in these User Terms will have the meaning
   assigned to them here below:</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c1" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(i)
   “Account” shall mean the account created by the Customer on the Application for
   availing the Services provided by Transpo.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c28" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(ii)
   “Additional Fee” shall mean any toll duty, inter-state taxes, etc. as may not
   be included in the Fare or not already paid as a part of the Total Ride Fee but
   payable to any third party / government authorities for undertaking the Ride
   under Applicable Law.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c28" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(iii)
   “Applicable Laws” shall mean and include all applicable statutes, enactments,
   acts of legislature or parliament, laws, ordinances, rules, by-laws,
   regulations, notifications, guidelines, policies, directions, directives and
   orders of any governmental authority, tribunal, or a court of India.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c34" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(iv)
   “Application” shall mean the mobile application “Transpo Cabs” updated by
   Transpo from time to time.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm"><span style="mso-spacerun:yes">&nbsp;</span>(v) “City of Operation” shall mean a city in
   which the Customers and TPSPs avail and render the transportation services
   respectively. For clarity, the services rendered by the TPSPs and availed by
   the Customers shall be in the same city.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c23" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(vi)
   “Customer/ You” means a person who has an Account on the Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c40" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(vii)
   “Driver” shall mean and include such individuals as may be evaluated, appointed
   and trained by an operator associated with us to provide the transportation
   services on its behalf and persons who are registered with Transpo and own the
   Vehicles and who have necessary city taxi permits and other applicable
   transport vehicle permits and licenses to provide transportation services
   within the City of Operation.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c77" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(viii)
   “E-Wallet” shall mean a pre-paid instrument, which can be used to make
   payments.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c3" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(ix)
   “Fare” shall mean such amount in Indian Rupees, which is reflected on the
   Application, as the fare payable for the specific Ride performed by a Driver.
   The Fare shall be exclusive of all applicable taxes on the Fare, if any. In
   relation to Auto (a motor cab), the Fare shall be as prescribed by law and/or
   as stipulated by relevant authorities.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(x)
   “Force Majeure Event” shall mean any event arising due to any cause beyond the
   reasonable control of Transpo.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xi)
   “Transpo” or “us” or “we” or “our” shall mean ANI Technologies Private Limited,
   a company incorporated under the provisions of the Companies Act, 1956 and
   having its corporate office at 4th Floor, Cherry Hills, Embassy Golf Links,
   Domlur, Bangalore-71, which expression shall, unless it be repugnant to the
   context or meaning thereof, be deemed to mean and include all its successors,
   affiliates and permitted assigns.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c28" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xii)
   “Registration Data” shall mean and may include the present, valid, true and
   accurate name, email ID, phone number and such other information as may be
   required by Transpo from the Customer from time to time for registration on the
   Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c19" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xiii)
   “Ride” shall mean the travel in the Vehicle by the Customer facilitated through
   the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xiv)
   “Service(s)” means the facilitation of transportation service by Transpo
   through the Application or via a telephone request at the call center of
   Transpo, or booking on the Site, within the City of Operation, as elaborated in
   Clause 4.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c56" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xv)
   “Site” shall mean the Application and the website https://www.Transpocabs.com/
   operated by Transpo or any other software that enables the use of the
   Application or such other URL as may be specifically provided by Transpo.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xvi)
   “Substitute Vehicle” shall mean another vehicle arranged for transporting the
   Customers to his/her destination, in the event of a Vehicle breakdown.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c58" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xvii)
   “Total Ride Fee” shall mean and include the Fare, the Convenience Fee or Access
   Fee, the Cancellation Fee and Additional Fee and taxes as may be applicable from
   time to time.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c79" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xviii)
   “T&amp;Cs” and “User Terms” shall mean these Customer terms and conditions.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xix)
   “TPSP” shall mean a Driver and/or an operator associated with us offering the
   service of transporting Customers within the City of Operation as requested by
   the Customer on the Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c65" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xx)
   “Vehicle” shall mean a motor cab as defined under the Motor Vehicles Act,1988.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c39" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">2.
   ELIGIBILITY</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c29" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">You
   will be “Eligible” to use the Services only when You fulfil all of the
   following conditions: (i) You have attained at least 18 (eighteen) years of
   age. (ii) You are competent to enter into a contract under the Applicable Laws.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c4" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">If
   You reside in a jurisdiction that restricts the use of the Service because of
   age, or restricts the ability to enter into contracts such as this User Terms
   due to age, you must abide by such age limits.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c50" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.
   REGISTRATION AND ACCOUNT</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.1
   You understand and acknowledge that You can register on the Site only after
   complying with the requirements of this Clause 3 and by entering Your
   Registration Data.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c56" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.2
   You shall ensure that the Registration Data provided by You is accurate,
   complete, current, valid and true and is updated from time to time. We shall
   bear no liability for false, incomplete, old or incorrect Registration Data
   provided by You.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.3
   You are solely responsible for maintaining the confidentiality of Your
   Registration Data and will be liable for all activities and transactions that
   occur through Your Account, whether initiated by You or any third party. Your
   Account cannot be transferred, assigned or sold to a third party. We shall not
   be liable for any loss that You may incur as a result of someone else using Your
   password or Account, either with or without Your knowledge.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c30" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.4
   We reserve the right to suspend or terminate Your Account with immediate effect
   and for an indefinite period, if We have a reason to believe that the
   Registration Data or any</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c84" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">other
   data provided by You is incorrect or false, or that the security of Your
   Account has been compromised in any way, or for any other reason We may find
   just or equitable.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.5
   Except for the Registration Data or any other data submitted by You during the
   use of any other service offered through Site (“Permitted Information”),
   Transpo does not want You to, and You should not, send any confidential or
   proprietary information to Transpo on the Site or otherwise, unless otherwise
   is required by Applicable Laws. In accepting these User Terms, you agree that
   any information or materials that You or individuals acting on Your behalf
   provide to Transpo other than the Permitted Information will not be considered
   confidential or proprietary.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c4" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.6
   It is Your responsibility to check to ensure that You download the correct
   application for Your device. We are not liable if You do not have a compatible
   mobile device or if You download the wrong version of the Application for Your
   mobile device. We reserve the right to terminate the Service and the use of the
   Application should You be using the Service or Application with an incompatible
   or unauthorized device.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">3.7
   We allow You to open only one Account in association with the Registration Data
   provided by You. In case of any unauthorized use of Your Account please
   immediately reach Us at </span></span><span class="MsoHyperlink"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;border:none windowtext 1.0pt;
      mso-border-alt:none windowtext 0cm;padding:0cm"><a href="mailto:support@transpoindia.in">support@transpoindia.in</a></span></span>
            <span class="c0">
      <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
         border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">
         .
         <o:p></o:p>
      </span>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm"><span style="mso-spacerun:yes">&nbsp;</span>3.8 In case, you are unable to access Your
   Account, please inform Us at support@transpoindia.in and make a written request
   for blocking Your Account. We will not be liable for any unauthorized
   transactions made through Your Account prior to the expiry of 72 (seventy-two)
   hours after You have made a request in writing for blocking Your Account, and
   shall not have any liability in case of Force Majeure Event.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c42" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.
   SERVICES</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c80" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.1.
   The Site permits you to avail the transportation services offered by TPSPs. The
   Service allows You to send a request through Transpo to a Driver on the Transpo
   network. The Driver has sole and complete discretion to accept or reject each
   request for Service. If the Driver accepts a request, Transpo notifies You and
   provides information regarding the Driver - including Driver name, Vehicle
   license number, telephone contact details of the Driver and such other details
   as Transpo may determine.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c29" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.2.
   Transpo shall procure reasonable efforts to bring You into contact with a
   Driver, subject to the availability of Driver in or around Your location at the
   moment of Your request for such services.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c35" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.3.
   By using the Application or the Service, You further agree that: (i) You will
   only use the Service or download the Application for Your sole, personal use
   and will not resell or assign it to a third party; (ii) You will not use an
   account that is subject to any rights of a person other than You without
   appropriate authorization; (iii) You will not use the Service or Site for
   unlawful purposes; (iv) You will not try to harm the Service, Site or our
   network in any way whatsoever; (v) You will provide Transpo with such
   information and documents which Transpo may reasonably request; (vi) You will
   only use an authorized network to avail the Service; (vii) You are aware that
   when requesting Services, whether by message, via Site or calling the call
   center of Transpo, standard messaging charges, data charges, voice charges, as
   applicable, of the Your and Our phone network service providers, will apply;
   (viii) You will comply with all Applicable Law from Your country of domicile
   and residence and the country, state and/or city in which You are present while
   using the Site or Service; and (ix) You are aware of and shall comply with the
   Information Technology Act, 2000 and the rules, regulations and guidelines
   notified thereunder.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.4.
   Transpo reserves the right to immediately terminate the Service and the use of
   the Application in the event of non-compliance with any of the above
   requirements. Further, Transpo will store the information provided by You or
   record your calls for contacting You for all Service-related matters. You shall
   promptly inform Transpo on any change in the information provided by You.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.5.
   Transpo or an authorized representative of Transpo, shall provide information
   regarding services, discounts and promotions provided by Transpo to You by way
   of an SMS or email to Your registered mobile number/registered email ID. You
   also have the option to discontinue receiving such information at any point of
   time. To discontinue receiving such information, you may at any point of time
   visit the specific link provided in the Site to discontinue the same.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.6.
   TRANSPO WILL BE ENTITLED TO PROCESS AND TRANSFER YOUR INFORMATION AS AND WHEN
   IT DEEMS FIT AND IT MAY STORE OR TRANSFER YOUR INFORMATION IN A SERVER OUTSIDE
   INDIA OR THE COUNTRY WHERE YOU ARE LOCATED IN ORDER TO PERFORM TRANSPO’S
   OBLIGATIONS UNDER THESE CUSTOMER T&amp;C.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.7.
   You agree to grant Transpo a non-exclusive, worldwide, perpetual, irrevocable,
   royalty- free, sub-licensable (through multiple tiers) right to exercise the
   copyright, publicity, database rights or any other rights You have in your
   information, in any media now known or not currently known, with respect to Your
   information. YOU AGREE AND PERMIT TRANSPO TO SHARE YOUR INFORMATION AND/OR
   PERMITTED INFORMATION, WITH THIRD PARTIES.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c14" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.8.
   You agree and permit Transpo to share any information provided by You with
   third parties in order to facilitate provision of certain value-added services
   offered by such third parties to You and/or to provide certain value-added
   services to You by Transpo. You hereby expressly consent to receive
   communications from Transpo/ third parties offering value-added services to You
   through Your registered phone number and/or e-mail id and/or the Site. You
   agree that You will not hold Transpo responsible for any such communications
   received from third parties, nor will any such communication amount to spam,
   unsolicited communication or a violation of Your registration on the national
   do not call registry.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.9.
   Transpo will be entitled to enter into any tie-up in terms of joint-venture or
   otherwise with any other institution engaged in the business of providing
   services analogous and/or similar to those herein contained. In such case,
   depending upon the modality and the mechanism as may be devised, you will be
   provided with the services by Transpo jointly and/or severally with the parties
   in joint venture. You hereby give Your irrevocable consent and permission to
   such a tie-up. In the event of such a tie-up, the terms and conditions herein
   contained will, mutatis mutandis, become applicable in respect of such tie-up
   arrangement also.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c15" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.10.
   In the event Transpo provides You any device as a part of the Services
   including but not limited to TRANSPO Play (“TRANSPO Device”), You shall comply
   with the following. ‘TRANSPO Play’ means a connected car platform using
   multiple devices in-car and cloud technology platform owned and operated by
   Transpo, which endeavors to provide an interactive experience to You – (i) You
   shall not tamper, pilfer or misuse the TRANSPO Device(s) or allow, induce or
   assist a third party to indulge in such activity. (ii) You shall not
   transcribe, distribute, download, store, duplicate and reproduce the content
   forming part of the TRANSPO Device(s) (“Content”), in whole or in part, through
   any medium including, but not limited to, tape, disc, hard disk, computer
   system, or other electronic recording or transmission device. (iii) You shall
   not (i) license, sublicense, sell, resell, transfer, assign, distribute or
   otherwise commercially exploit or make available to any third party, in any
   way, the TRANSPO Device(s) and/or any Content; (ii) modify or make derivative
   works from the Content; (iii) create Internet “links” to the Content or “frame”
   or “mirror” any Content on any other server or wireless or internet-based
   device; (iv) reverse engineer or access the TRANSPO Device(s) and/or Content in
   order to (a) design or build a competitive product or service, (b) design or
   build a product using similar ideas, features, functions or graphics of the
   TRANSPO Device(s) and/or Content, or (c) copy any ideas, features, functions or
   graphics of the TRANSPO Device(s) and/or Content, or (v) launch an automated
   program or script, including, but not limited to, web spiders, web crawlers,
   web robots, web ants, web indexers, bots, viruses or worms, or any program
   which may make multiple server requests per second, or unduly burdens or
   hinders the operation and/or performance of the TRANSPO Device and/or Content
   (iv) You shall not use the TRANSPO Device(s) for any illegal or unlawful
   purposes including but not</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c33" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">limited
   to playing / watching pornographic content on the TRANSPO Device and shall use
   the TRANSPO Device(s) solely for purposes determined by Transpo and strictly in
   accordance with these User Terms. You shall solely be responsible and liable
   for any transportations of law committed by You and misuse of the TRANSPO
   Device(s), if any, with the TRANSPO Device(s). (v) You shall ensure that the
   TRANSPO Device(s) is maintained in Your possession in a proper manner. Transpo
   may, at its sole discretion, charge such amounts from You as may be determined
   by Transpo for use of the TRANSPO Device(s) by You. (vi) In the event the
   TRANSPO Device(s) is not functioning properly or if there is any technical or
   safety issue in relation to the TRANSPO Device(s), You shall immediately inform
   the Driver about any such issue. (vii) You shall use the TRANSPO Device(s) with
   due care and caution and not do anything or permit anything to be done that may
   cause damage to the TRANSPO Device(s). If the TRANSPO Device(s) is damaged and
   is not repairable due to any act of You, you shall pay amounts to Transpo, as
   may be determined by Transpo. If You fail or are unable to pay the amounts
   determined by Transpo, Transpo shall be entitled to suspend / terminate Your
   Account with Transpo without prejudice to Transpo’s rights under these User
   Terms and under Applicable Laws.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c66" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.11.
   In the event of breakdown of the Vehicle, which is beyond repair, before
   completion of the Ride, Transpo on a best effort basis and at its sole
   discretion may arrange for a Substitute Vehicle for completion of Your Ride to Your
   destination. However, the arrangement of Substitute Vehicle shall be subject to
   its availability.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c74" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.12.
   You acknowledge and agree that Substitute Vehicle may not be necessarily of the
   same type as the original Vehicle booked by You from the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">4.13.
   Transpo bears no responsibility and liability for delays and losses suffered by
   You or caused to You as a consequence of the breakdown of the Vehicle or the
   Substitute Vehicle.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c82" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">5.
   CONFIRMATION OF BOOKING</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">5.1.
   Transpo shall, upon receiving the booking request from You in the manner set
   out above, proceed to confirm or decline the booking based on the availability
   of Vehicles at the pickup time, which shall be informed to You via an SMS or
   email. In the event the booking is confirmed, you shall check the booking
   details including but not limited to pick up time and pick up place, and if
   there is incorrect detail, the same needs to be informed to us immediately by
   calling our call center.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">5.2.
   You shall bear the consequences and damages for any delay that may be caused to
   You due to Your failure to check the confirmation SMS or email or failure to
   inform Transpo of the incorrect details immediately.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c78" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">5.3.
   Certain selective customers will be eligible to avail the Service under a
   ‘Guest Booking’ feature, provided by Transpo. Such customers will also be bound
   by the terms and conditions set out herein.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c27" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.
   PAYMENT</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.1.
   Transpo shall charge Convenience Fee or Access Fee for the Service which shall
   be determined and amended at the sole and absolute discretion of Transpo. The
   Convenience Fee or Access Fee shall be payable by you to Transpo and shall be
   informed to you before you begin your ride.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c1" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.2.
   In relation to Transpo Autos plying within the City of Operation the
   Convenience Fee or Access Fee shall not exceed an amount of Rs 75 at any time.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c13" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.3.
   TPSP shall charge Fare to You for the Ride offered to You by the TPSP.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c19" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.4.
   You shall be required to pay such Additional Fee, which will form part of the
   receipt of the Total Ride Fee.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c41" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0">
      <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
         border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">
         6.5.
         You shall be required to pay such Cancellation Fee in terms of Clause 7, which
         will form part of the receipt of the Total Ride Fee.
         <o:p></o:p>
      </span>
   </span>
          </p>
          <p class="c41" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.6.
   In addition to the Total Ride Fee, You may be required to pay such other
   charges incurred by you during the Ride in cash i.e. Additional Fee, which are
   not included in the receipt of the Total Ride Fee.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.7.
   The Total Ride Fee will be collected by the Driver or Transpo from You at the
   end of the Ride, as set out in Clause 6.7 below.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.8.
   Transpo shall provide a receipt of the Total Ride Fee payable by You at the end
   of the Ride, however, separate invoices raised by the TPSPs for the Fare and
   Additional Fee, and the Convenience Fee or Access Fee raised by Transpo shall
   be provided to You on request. You may raise a request for a copy of the
   invoices from our Support page.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c7" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.9.
   All applicable taxes in respect of the Fare, Convenience Fee, Additional Fee,
   Cancellation Fee shall be borne and payable by You to the TPSPs or Transpo, as
   the case may be.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.10.
   You shall choose to pay for the Service Fee by either of the following four
   methods: (i) Cash payment: Cash payment towards the Total Ride Fee after the
   completion of Ride can be made to the Driver. (ii) E-Wallet payment: Transpo
   offers You the facility of making an online payment through an E-Wallet powered
   by a third-party payment processor (“Payment Processor”). E-Wallet money will
   not be applicable on bookings made through the phone or while the user is not
   logged into his/her Account on the Site. The processing of payments, in
   connection with Your use of the E-Wallet will be subject to the terms,
   conditions, and privacy policies of the Payment Processor that Transpo engages
   for the purpose. Transpo will not be responsible for any errors by the Payment
   Processor in any manner. Further, even in cases of E- Wallet payments, all
   Additional Fee (defined below) shall have to be paid by You in cash, to the
   authority or person concerned or if already paid by the Driver, to the Driver.
   When You choose to make an E-Wallet payment, Transpo shall collect the Fare on
   behalf of the TPSP who will be responsible for providing the transportation
   services. (iii) Transpo Credit Payment: Payment for the Total Ride Fee can be
   made to Transpo on credit subject to the terms provided at
   https://s3-ap-southeast- 1.amazonaws.com/Transpo-prod-website/TERMS+AND+CONDITIONS_TRANSPO+CREDIT.pdf
   Further, even in cases of Transpo Credit payments, all Additional Fee shall
   have to be paid by You in cash, to the authority or person concerned or if
   already paid by the Driver, to the Driver. When You choose to make a Transpo
   Credit payment, Transpo shall collect the Fare on behalf of the TPSP who will
   be responsible for providing the transportation services. (iv) Credit Card/
   Debit Card/ Net Banking Payment: Total Ride Fee shall be affected using the
   services of an entity providing payment gateway/processor services (“PG”),
   authorized by Transpo. Such PG may either be Transpo or any of its affiliates
   or partners or unrelated third parties. You agree and undertake to share
   relevant payment details including credit/debit card details (Card Details)
   with the PG for the successful completion of payment towards Total Ride Fee to
   Transpo and authorize the PG to complete such transactions. In this respect, it
   is clarified that all PGs whose services are utilized for the purposes of the
   Site and/or Application and/or Services shall be PCI-DSS (Payment Card Industry
   – Data Security Standard) compliant. Your authorization permits the PG to debit
   or credit the bank account associated with Your payment details. Your
   authorization further permits the PG to use Your Card Details for the
   processing of transactions initiated by You at any of Transpo’s affiliates. Your
   authorization will remain in effect as long as You maintain an Account with Us.
   In the event You delete Your Card Details with the PG or if You delete Your
   Account, the PG will not process any further transactions initiated by You at
   the Site or Application and at the sites of any of Transpo’s affiliates. Your
   authorization under this clause is subject to any other terms and conditions of
   the PG.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c31" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">6.11.
   Any payment related issue, except when such issue is due to an error or fault
   in the Site, shall be resolved between You and the Payment Processor. Transpo
   shall not be responsible for any unauthorized use of Your E-Wallet during or
   after availing the Services on the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c36" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.
   CANCELLATION POLICY</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.1.
   You agree and acknowledge that You may cancel Your request for a Vehicle from a
   Driver at any point of time subject to a Cancellation Fee as explained below:
   In Micro/Mini/Prime/Sedan/SUV/Luxury/Rental categories, Cancellation Fee will
   be charged</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c6" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">•
   If you cancel after 5 minutes after the cab is allotted or • If a driver
   cancels after waiting at Your location for more than 10 minutes •
   Notwithstanding the foregoing, if the Driver is delayed by more than five (5)
   minutes to pick You, you will not be charged any Cancellation Fee.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c22" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.2.
   You shall be notified of the applicable Cancellation Fee in advance whenever You
   attempt to cancel a booking/service request. The notification shall be on the
   Application and/or the Site.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c3" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.3.
   Transpo shall provide a receipt of the Cancellation Fee, if any, payable by You
   for every cancellation in terms of the table above for such cancellations,
   however, separate invoices raised by the TPSPs for the Cancellation Fee, and
   Transpo for the Convenience Fee on cancellations shall be provided to You on
   request. You may raise a request for a copy of the invoices from the Support
   page.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.4.
   The Cancellation Fee shall be payable by You at the completion of Your
   subsequent Ride.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c1" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.5.
   The mode of payment of the Cancellation Fee shall be in terms of Clause 7 of
   these User Terms.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c30" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">7.6.
   This Clause 7 shall not apply to corporate rides availed pursuant to the terms
   and conditions.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c16" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">8.
   USER VIOLATION OF USER TERMS</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">8.1.
   You shall not smoke and drink in the Vehicles or misbehave with the Driver or
   distract the Driver or act in transportation of Applicable Law. In the event You
   are found to be involved in the activities set out above, you shall be liable
   to pay a fine to us and we shall also have the right to terminate the Ride. In
   the event You fail to pay fine after the completion of the Ride, we may at our
   discretion, take such steps as may be available to us under Applicable Law. You
   shall also be blacklisted as a result of non-payment of the fine or misbehaving
   as the case may be, and in such event, Your Account may be terminated by
   Transpo.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c76" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">9.
   CUSTOMER RELATIONSHIP MANAGEMENT 9.1. All issues, opinions, suggestions,
   questions and feedback while availing our Services shall be communicated to us
   through email address mentioned in Clause 22.2. In case of a Ride booked on our
   Application, you shall be required to rate the Ride after its termination. You
   agree to be fair, accurate and non-disparaging while leaving comment,
   feedbacks, testimonials or reviews on or about the Rides or Services.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c19" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">9.2.
   Reporting of any issue needs to be within 7 (seven) days of the happening of
   the issue, failing which, such issue will not be addressed.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c24" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">9.3.
   Any issue reported on channels other than the above may be addressed by Transpo
   only on a best-effort basis. Transpo takes no liability for inability to get
   back on other channels.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">9.4.
   Transpo shall endeavor to respond to Your issues within 2 (two) working days of
   Your reporting the same and endeavor to resolve it at the earliest possible. It
   is hereby clarified that issues are resolved on severity basis, and certain may
   be resolved earlier than the other. However, Transpo shall not be liable for
   any damages or losses in the event You are not satisfied with any such
   resolution.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c63" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.
   EMERGENCY SERVICES TO CUSTOMER</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c4" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.1
   By accepting these User Terms and on pressing the SOS button on the Transpo
   App, You consent to Transpo using its best endeavors to provide You with
   assistance during a safety incident, emergencies or distress, as per Transpo’s
   internal policies on emergency response. Transpo may undertake remedial
   action(s), including, but not limited to the following:</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c56" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.1.1
   When you press the SOS button and report a safety incident, the Transpo
   representative may escalate the incident internally or liaise with any third-party
   security service providers to assist You and/or deploy response teams to Your
   location.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.1.2
   Transpo may inform any government authorities, such as the concerned police
   station, about the incident and seek their assistance; Transpo may also provide
   such authorities) with your personal information including but not limited to your
   exact GPS location, your registered email ID and mobile number to enable them
   to take appropriate steps to assist You.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c28" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.1.3
   Transpo may engage third party security providers to assist You and Transpo in
   addressing the incident. For this purpose, Transpo may share your personal
   information, including but not limited to, your exact GPS location, your
   registered email ID and mobile number with third</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c25" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">parties
   such as a security services provider, to enable them to take appropriate steps
   to assist You and solely to resolve the incident.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c22" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.1.4
   Further to the above, You may receive telephone calls from an Transpo representative
   and/or the relevant response team at the time of pressing the SOS button and in
   the duration that the incident is being resolved, and the same shall not be
   construed as breach of TRAI guidelines, in as much as these would be made for Your
   security and safety purposes.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c29" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.2
   Under this clause, you give Your express consent to permit Transpo to undertake
   the above along with any ancillary actions that may be required to facilitate
   an effective emergency response.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">10.3
   Transpo will not be liable for any deficiency of service, provided to You under
   this clause on a best efforts basis, and this clause does not, in any manner,
   restrain You from seeking any other form of assistance from any other party.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c55" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">11.
   FORCE MAJEURE</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c30" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">11.1
   We shall not be liable for any failure to perform any obligations under this
   User Terms, if the performance is prevented, hindered or delayed by a Force
   Majeure Event and in such case our obligations under this User Terms shall be
   suspended for so long as the Force Majeure Event continues.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c70" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">12.
   INDEMNIFICATION</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c7" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0">
      <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
         border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">
         12.1
         By accepting these User Terms and using the Service, You agree that You shall
         defend, indemnify and hold Transpo, its affiliates, their licensors, and each
         of its officers, directors, other users, employees, attorneys and agents
         harmless from and against any and all claims, costs, damages, losses,
         liabilities and expenses (including attorneys' fees and costs) arising out of
         or in connection with: (a) Your violation or breach of any term of these User
         Terms or any Applicable Law or regulation, whether or not referenced herein;
         (b) Your violation of any rights of any third party, including the TPSPs \or
         (c) Your use or misuse of the Application or Service.
         <o:p></o:p>
      </span>
   </span>
          </p>
          <p class="c7" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p>&nbsp;</o:p>
   </span>
          </p>
          <p class="c62" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.
   LIABILITY</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.1.
   The information, recommendations and/or Services provided to You on or through
   the Site, the Application and Transpo call center are for general information
   purposes only and does not constitute advice. Transpo will reasonably keep the
   Site and its contents correct and</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c5" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">up
   to date but does not guarantee that (the contents of) the Site is free of
   errors, defects, malware and viruses or that the Site is correct, up to date
   and accurate.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.2.
   Transpo shall not be liable for You missing trains/flights/events or delays
   etc. as the Service is dependent on many factors not in Transpo’s control. You
   must book Your Ride after taking into account the check-in time, traffic and
   weather conditions, political rallies, natural calamities, traffic barricades,
   car breakdowns and other un-expected delays.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c4" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.3.
   In the event, there is a delay by the Vehicle in reaching the pickup location
   beyond 30 (thirty) minutes of the pickup time, Transpo shall only endeavor to
   get You in touch with the Driver assigned for Your Ride.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.4.
   Transpo shall not be liable for any damages resulting from the use of or
   inability to use the Site, including damages caused by wrong usage of the Site,
   error in call center number, network issues, malware, viruses or any
   incorrectness or incompleteness of the Information or the or Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.5.
   You shall take full responsibility of Your items and luggage. In case of lost
   items inside the Vehicle during the journey, Transpo will try to locate the
   items on a “best-effort” basis but is not responsible for the same in case of
   loss or damage to the same. If You leave any goods in the Vehicle or have any
   complaint in respect of the Services or the use of the Vehicle, you have to
   inform Transpo of the same in writing within 24 (twenty-four) hours of using
   the Vehicle or the Services of Transpo. In the event it is found, you shall be
   informed about the Transpo office from where You can collect it after 3 (three)
   working days from the date You were informed. Transpo however shall not be
   responsible for delivering the same back to You. If requested, Transpo may
   deliver the misplaced item/s back to You after 3 (three) working days from the
   date You were informed, subject to the place of delivery being twenty (20) kms
   from the Transpo office. Transpo shall charge You a flat fee of Rs 500 for such
   delivery.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c61" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">13.6.
   Transpo does not assure a complete sustainability of its Service and shall not
   be held responsible or liable for the same, in any manner.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0">
      <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
         border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">
         13.7.
         Transpo shall not be responsible for any loss of communication / information of
         status update and benefits under the program. All this information will be sent
         on mobile number and/or email ID registered with Transpo. Transpo will not be
         responsible for appropriateness of mobile or email or any other communication
         medium. You shall be responsible for immediately reporting the errors, if any,
         occurred in the information sent to You regarding booking confirmation.
         <o:p></o:p>
      </span>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p>&nbsp;</o:p>
   </span>
          </p>
          <p class="c81" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0">
      <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
         border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">
         14.
         APPLICATION LICENSE
         <o:p></o:p>
      </span>
   </span>
          </p>
          <p class="c81" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p>&nbsp;</o:p>
   </span>
          </p>
          <p class="c47" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">14.1.
   Subject to Your compliance with these User Terms, Transpo grants You a limited,
   revocable, non-exclusive, non-transferable and non-sub-licensable license to
   download and install a copy of the Application on a single mobile device that You
   own or control and to run such copy of the Application solely for Your own
   personal use and to use the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c3" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">14.2.
   You shall not (i) license, sublicense, sell, resell, transfer, assign,
   distribute or otherwise commercially exploit or make available to any third
   party the Service or Site in any way; (ii) modify or make derivative works
   based upon the Service or Application; (iii) create Internet “links” to the
   Service or “frame” or “mirror” any Site on any other server or wireless or
   Internet-based device; (iv) reverse engineer or access the Site in order to (a)
   design or build a competitive product or service, (b) design or build a product
   using similar ideas, features, functions or graphics of the Service or Site, or
   (c) copy, reproduce, record, or make available to the public any ideas,
   features, functions or graphics of the Service or Site, or (v) launch an
   automated program or script, including, but not limited to, web spiders, web
   crawlers, web robots, web ants, web indexers, bots, viruses or worms, or any
   program which may make multiple server requests per second, or unduly burdens
   or hinders the operation and/or performance of the Service or Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c28" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">14.3.
   You shall not: (i) send spam or otherwise duplicative or unsolicited messages
   in violation of applicable laws; (ii) send or store infringing, obscene,
   threatening, libelous, or otherwise unlawful or tortious material, including
   material harmful to children or violative</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c35" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">of
   third party privacy rights; (iii) send or store material containing software
   viruses, worms, Trojan horses or other harmful computer code, files, scripts,
   agents or programs; (iv) interfere with or disrupt the integrity or performance
   of the Site, the Application or Service or the data contained therein; or (v)
   attempt to gain unauthorized access to the Site, the Application or Service or
   its related systems or networks.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c3" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">14.4.
   Transpo will have the right to investigate and prosecute violations of any of
   the above to the fullest extent of the law. Transpo may involve and cooperate
   with law enforcement authorities in prosecuting users who violate these User
   Terms. You acknowledge that Transpo has no obligation to monitor Your access to
   or use of the Site, Service or Posted Content, but has the right to do so for
   the purpose of operating the Site and Service, to ensure Your compliance with
   these User Terms, or to comply with Applicable Law or the order or requirement
   of a court, administrative agency or other Governmental body. Transpo reserves
   the right, at any time and without prior notice, to remove or disable access to
   any content that Transpo, at its sole discretion, considers to be in violation
   of these User Terms or otherwise harmful to the Site, the Service or
   Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c48" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">15.
   CONTENT POSTED BY CUSTOMERS</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">15.1.
   Transpo may accept posting of any notes, messages, e-mails, photos, drawings,
   profiles, opinions, ideas, images, videos, audio files or other materials or
   information given by you on the Site (“Posted Content”) by You. You represent
   that You have obtained all permissions and consents required to post the Posted
   Content and such Posted Content complies with all requirements of the Posted
   Content. Transpo shall not in any manner be responsible for or endorse the
   Posted Content.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c12" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">15.2.
   You agree that when posting Posted Content, You will not:</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c29" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(i)
   Publish, post, upload, distribute or disseminate any inappropriate, profane,
   defamatory, infringing, obscene, indecent or unlawful topic, blasphemous,
   pornographic, libelous, invasive of another's privacy, hateful, or racially,
   ethnically objectionable, disparaging, relating or encouraging money laundering
   or gambling, or otherwise unlawful material or information.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c56" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(ii)
   Upload files that contain software or other material protected by intellectual
   property laws (or by rights of privacy or publicity) unless You own or control
   the rights thereto or have received all necessary consents.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(iii)
   Upload files that contain viruses, corrupted files, or any other similar
   software or programs that may damage the operation of another’s computer.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c59" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(iv)
   Advertise or offer to sell or buy any goods or services for any business
   purpose, unless the Site specifically allows such messages.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c43" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(v)
   Conduct or forward surveys, contests, pyramid schemes or chain letters.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c34" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(vi)
   Download any file posted by another user that You know, or reasonably should
   know, cannot be legally distributed in such manner.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(vii)
   Falsify or delete any author attributions, legal or other proper notices or
   proprietary designations or labels of the origin or source of software or other
   material contained in a file that is uploaded.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c24" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(viii)
   Deceive or mislead the addressee about the origin of a message or communicate
   any information which is grossly offensive or menacing in nature.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c67" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(ix)
   Restrict or inhibit any other user from using and enjoying the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c60" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(x)
   Violate any code of conduct or other guidelines which may be applicable for any
   particular Posted Content.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c3" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(xi)
   Harvest or otherwise collect information about others, including e-mail
   addresses, without their consent. (xii) Threaten the unity, integrity, defence,
   security or sovereignty of India, friendly relations with foreign states, or
   public order or causes incitement to the commission of any cognizable offence
   or prevents investigation of any offence or is insulting any other nation.
   (xiii) Violate any Applicable Laws or regulations including the Information
   Technology Act, 2000 and the rules, regulations and guidelines notified
   thereunder.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c18" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">16.
   INTELLECTUAL PROPERTY OWNERSHIP</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">16.1.
   Transpo alone (and its licensors, where applicable) shall own all right, title
   and interest, including all related intellectual property rights, in and to (i)
   the Site, Application, product, Service and any suggestions, ideas, enhancement
   requests, feedback, recommendations or any other offering; (ii) text, graphics,
   user interfaces, visual interfaces, photographs, trademarks, logos, sounds,
   music, artwork and computer code; or (iii) other information provided by You or
   any other party relating to the Site, Application or the Service. Third party
   trademarks may appear on this Site/ Application and all rights therein are
   reserved to the registered owners of those trademarks. For use of any third
   party's intellectual</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c9" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">property,
   you need to get permission directly from the owner of the intellectual property
   for any use.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">16.2.
   These User Terms do not constitute a sale and do not convey to You any rights
   of ownership in or related to the Site, the Application or the Service, or any
   intellectual property rights owned by Transpo. You shall be solely responsible
   for any violations of any laws and for any infringements of any intellectual
   property rights caused by use of the Services or the Site/ Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c2" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">16.3.
   You may use information on the Site purposely made available by Transpo for
   downloading from the Site, provided that You:</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">(i)
   do not remove any proprietary notice language in all copies of such documents
   and make no modifications to the information; (ii) use such information only
   for Your personal, non-commercial informational purpose and do not copy or post
   such information on any networked computer or broadcast it in any media; or
   (iii) do not make any additional representations or warranties relating to such
   information.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c75" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">17.
   LINKS</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">17.1.
   If permitted by Transpo, you may establish a hypertext link to the Site,
   provided that the link does not state or imply any sponsorship or endorsement
   of Your site by Us. You must not use on Your site or in any other manner any
   Transpo trademarks or service marks or any Content belonging to Transpo and
   appearing on the Site, including any logos or characters, without our express
   written consent. You must not frame or otherwise incorporate into another third-party
   website or present in conjunction with or juxtaposed against such a website any
   of the content or other materials on the Site without our prior written
   consent.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c26" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">18.
   TERM AND TERMINATION OF LICENSE AGREEMENT</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c21" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">18.1.
   Unless terminated in accordance with this Clause 17, the agreement between
   Transpo and You is perpetual in nature upon downloading the Application and for
   each Ride booked through the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c37" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">18.2.
   You are entitled to terminate the agreement at all times by deletion of Your
   Account, thus disabling the use by You of the Site. You can close Your Account
   at any time by following the instructions on the Site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c38" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">18.3.
   Transpo is entitled to terminate the agreement at all times and with immediate
   effect (by disabling Your use of the Site and the Service) if You: (a) violate
   or breach any term of</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c14" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">these
   User Terms, or (b) in the opinion of Transpo, misuse the Application or the
   Service. Transpo is not obliged to give notice of the termination of the
   agreement in advance. After termination Transpo will give notice thereof in
   accordance with these User Terms.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c30" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">18.4.
   Termination of this agreement will not prejudice accrued rights of either
   Transpo or You.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">18.5.
   Clauses 11 (Indemnification), 12 (Liability), 13 (Application License), 14
   (Contents posted on Site/ Application), 15 (Intellectual Property Ownership), 17
   (Term and Termination), 22 (Notice) and 24 (Applicable Law and Dispute
   Resolution) and such other provisions which are intended to survive the
   termination, shall survive the expiry/termination of these User Terms in
   accordance with their terms.</span></span>
            <span lang="EN-US" style="font-family:
      &quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c53" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">19.
   INVALIDITY OF ONE OR MORE PROVISIONS</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">19.1.
   The invalidity of any term of these User Terms shall not affect the validity of
   the other provisions of these User Terms. If and to the extent that any
   provision of these User Terms is invalid, or is unacceptable in the given
   circumstances, a provision shall apply between the parties instead that is
   acceptable considering all the circumstances, taking into account the content
   and the purpose of these User Terms.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c24" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">20.
   CONFLICT In the event of any contradiction or inconsistency between this User
   Terms and any other agreement executed between You and Transpo, the terms of
   the User Terms shall prevail unless the exception has been expressly agreed to
   in writing by making reference to the relevant Clause sought to be modified under
   this User Terms.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c64" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.
   DISCLAIMER</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c32" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.1.
   You agree that Transpo is merely an electronic platform to facilitate
   aggregation of Vehicles and does not in any manner provide transportation
   services. Transpo does not endorse, advertise, advise or recommend You to avail
   the Services of any Driver. Transpo also does not guarantee or provide
   assurance in respect of the behavior, actions or data of the users posted on
   the site.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c19" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.2.
   We do not authorize anyone to make a warranty on Our behalf and You shall not rely
   on any statement of warranty as a warranty by Us.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c17" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.3.
   Transpo and their representatives, officers, employees, agents and contractors
   shall not be liable for any loss, damage, claim, expense, cost (including legal
   costs) or liability arising directly or indirectly from Your use or non-use of
   the Service or the Site, or Your reliance</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c5" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">upon
   the Service or the information contained upon the Site (whether arising from
   Transpo or any other person's negligence or otherwise).</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c8" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.4.
   This Site, Application and all content on the Site and the Application are
   provided on an “as is” basis without warranties of any kind, either express or
   implied, including without limitation warranties of title or implied warranties
   of merchantability or fitness for a particular purpose. You acknowledge, by Your
   access of the Site and/or Application, that Your access of the Site and/or
   Application and availing of Services is at Your sole risk, that You assume full
   responsibility for Your access and use of the Site and/or Application, and that
   Transpo shall not be liable for any damages of any kind related to Your access
   and use of this Site and/or Application.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c28" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.5.
   All images, audio, video and text in the Site and/or Application are only for
   illustrative purposes. None of the models, actors or products in the images, if
   any is endorsing the Services in any manner. Any resemblance of any matter to
   anybody or anything is purely unintentional and/or coincidental.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c3" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">21.6.
   Transpo is not engaged in the insurance business and does not provide any
   insurance services. Transpo has facilitated provision of insurance services for
   the benefit of Customers, under group travel insurance policies availed from
   insurance companies, whereby Transpo is acting as the group manager of the
   policy. Transpo does not guarantee or make any promise in relation to the
   insurance policy/ insurance company, including but not limited to any benefits
   from use of the insurance services provided by the insurance companies, such as
   coverage, claims and settlements. Any claim or servicing of insurance policies,
   raised through the Application, remains a matter between the Customer and the
   insurance company, and Transpo shall not be responsible for the actions of the
   insurance company or the Customer. It is to be noted that the insurance policy
   number, claim certificate, invoice for the insurance premium/ fee collected
   from the Customer is not be issued by Transpo, but will be issued by the
   respective insurance company. Any issues in receiving tax invoices or issues
   faced in claiming the insurance are not the responsibility of Transpo. Transpo
   disclaims all and all liability in relation to the services of the insurance
   company. Please reach out to the insurance company in case of any questions/
   issues.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c10" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">22.
   MODIFICATION OF THE SERVICE AND USER TERMS</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c22" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">22.1.
   Transpo reserves the right, at its sole discretion, to modify or replace, in
   part or full, any of these User Terms, or change, suspend, block, discontinue
   or restrict your use to all or any feature of the Service or Application at any
   time.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;
      color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="c76" style="margin:0cm;margin-bottom:.0001pt;vertical-align:baseline">
   <span class="c0"><span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222;
      border:none windowtext 1.0pt;mso-border-alt:none windowtext 0cm;padding:0cm">22.2.
   Transpo shall not be required to notify You of any changes made to these User
   Terms. The revised User Terms shall be made available on the Site. You are
   requested to regularly visit the Site to view the most current User Terms. You
   can determine when Transpo last modified the User Terms by referring to the
   “Last Updated” legend above. It shall be Your responsibility to check these
   User Terms periodically for changes. Transpo may require You to provide Your
   consent to the updated User Terms in a specified manner prior to any further
   use of the Site and the Services. If no such separate consent is sought, your
   continued use of the Site, following the changes to the User Terms, will
   constitute Your acceptance of those changes. Your use of the Site and the
   Services is subject to the most current version of the User Terms made
   available on the Site at the time of such use.</span></span>
            <span lang="EN-US" style="font-family:&quot;Segoe UI&quot;,sans-serif;color:#222222">
      <o:p></o:p>
   </span>
          </p>
          <p class="MsoNormal">
   <span lang="EN-US">
      <o:p>&nbsp;</o:p>
   </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Button, FormGroupInput } from '@/components';
  export default {
    name: 'privacy-policy',
    bodyClass: 'landing-page',
    components: {
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        form: {
          firstName: '',
          email: '',
          message: ''
        }
      };
    }
  };
</script>
<style>
  .wrapper {
    background-color: #94969c;
  }
</style>
